var exports = {
  "uW": "x31de4314--791900--section",
  "J6": "x31de4314--791900--left-column",
  "wW": "x31de4314--791900--right-column",
};

module.exports = exports;
